import PositionManagement from './../../inventory_check/views/position_management'
import { useTranslation } from 'react-i18next';
import { GalleryMain } from './../../media_classification_storage/views/document_management'
import { Row, Col, Modal, Button, Form, Typography, Seperator, Card, DatePicker, Tag, TimeSelector, jsonToQueryString, Select } from "../../ui/ot"
import Staff, { StaffForm } from '../../organization_structure/Staff';
import dayjs from 'dayjs';
import axios from "axios";
import { useState, useEffect, useRef } from 'react';
import MediaContent from '../../media_classification_storage/views/media_content';
import Upload_modal from '../../media_classification_storage/Upload_ot_modal';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useCRUDController } from '../../ui/classify_structure/CRUDController';
const SpaceManagement = ({
    propsForm,
    onFormFinish = () => { },
    defaultSelectedRowsInfo = [],
    defaultSelectedRowsKeys = [],
    keyPrefix = "reservation_registration_and_space_management.space_management",
    propsModeActiveTabHidden = true,
    depth = 0,
    only_depth = 0,
    onSelectChange = (() => { }),
    toolBarRender = (tools) => ([...tools]),
    rowSelectionMode = 'checkbox',
    readonly = false,
    extraParams = {},
    propsClassifyStructureTypeId = 0,
    get_position_mode = 'top',
    propsModeActiveKey = 'list',
    propsCardRenderMode = 'origin',
    defaultDayPickerSearch,
    propsDepthTabs,
    propsShowKeys =
    [
        { key: "name", name: "name", hidden: false, require: false },
        { key: "name_en", name: "name_en", hidden: false, require: false },
        { key: "location", name: "location", hidden: true, require: false },
        { key: "space", name: "space", hidden: true, require: false },
        { key: "capacity", name: "capacity", hidden: true, require: false },
        { key: "row", name: "row", hidden: true, require: false },
        { key: "column", name: "column", hidden: true, require: false },
        { key: "height", name: "height", hidden: true, require: false },
        { key: "position_attribute_data", name: "position_attribute_data", hidden: true, require: false },
        { key: "Seperator1", name: "Seperator1", hidden: true, require: false },
        { key: "Seperator2", name: "Seperator2", hidden: true, require: false },
        { key: "x", name: "x", hidden: true, require: false },
        { key: "y", name: "y", hidden: true, require: false },
        { key: "z", name: "z", hidden: true, require: false },
        { key: "max", name: "max", hidden: true, require: false },
        { key: "min", name: "min", hidden: true, require: false },
        { key: "row", name: "row", hidden: true, require: false },
        { key: "column", name: "column", hidden: true, require: false },
        { key: "height", name: "height", hidden: true, require: false },
        { key: "seating_and_space_status", name: "seating_and_space_status", hidden: false, require: false },
        { key: "can_reserve_time_string", name: "can_reserve_time_string", hidden: false, require: false },
        { key: "space_management_schedule_data", name: "space_management_schedule_data", hidden: false, require: false },
        { key: "staff_name", name: "staff_name", hidden: false, require: false },
        { key: "create_time", name: "create_time", hidden: false, require: false },
        { key: "schedule_id", name: "schedule_id", hidden: false, require: false },
        { key: "position_can_reserve_time", name: "position_can_reserve_time", hidden: false, require: false },
        { key: "position_can_reserve_time", name: "position_can_reserve_time", hidden: false, require: false },
        { key: "classify_structure_type_id", name: "classify_structure_type_id", hidden: false, require: false },
        { key: "create_user", name: "create_user", hidden: false, require: false },
    ],
    ...props
}) => {
    const actionRef = useRef(null);
    const [searchParams] = useSearchParams()
    const { space_managment_id } = Object.fromEntries([...searchParams])
    const { t } = useTranslation('translation', { keyPrefix })
    const [staff_data, set_staff_data] = useState({})
    const [dayPickerSearch, setDayPickerSearch] = useState(defaultDayPickerSearch)
    const [form_] = Form.useForm();
    const navigate = useNavigate()
    const form = propsForm || form_

    const getFormValues = () => {
        let values = {}
        values = form.getFieldsValue()
        return values
    }
    const onFinish = () => {
        const values = getFormValues();
        onFormFinish({
            ...values,
        })
    }

    const scheduleController = useCRUDController({
        apiRoute: '/reservation_registration_and_space_management/schedule'
    })
    const rentController = useCRUDController({
        apiRoute: '/reservation_registration_and_space_management/rent',
        onFinish: ({ axiosMode, status }) => {
            actionRef?.current?.reload()
        }
    })
    useEffect(() => {
        scheduleController.getData({})
    }, [])
    return <>
        <PositionManagement
            actionRef={actionRef}
            propsDepthTabs={propsDepthTabs}
            readonly={readonly}
            propsForm={form}
            onSelectChange={onSelectChange}
            depth={depth}
            only_depth={only_depth}
            defaultSelectedRowsInfo={defaultSelectedRowsInfo}
            defaultSelectedRowsKeys={defaultSelectedRowsKeys}
            initialValues={{
                staff_name: staff_data?.staff_name,
                create_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
            }}
            api={'/reservation_registration_and_space_management/space_management'}
            propsActiveTabHidden={true}
            propsActiveKey={''}
            propsModeActiveTabHidden={propsModeActiveTabHidden}
            propsModeActiveKey={propsModeActiveKey}
            get_position_mode={get_position_mode}
            extraParams={{
                date: dayPickerSearch ? new Intl.DateTimeFormat('en-US').format(dayPickerSearch) : null,
                classify_structure_id: 29,
                classify_structure_type_id: 0,
                ...extraParams
            }}
            keyPrefix={`${keyPrefix}.position`}
            toolBarRender={(tools) => toolBarRender([
                ...(propsModeActiveTabHidden || readonly ? [] : [<Row align="middle" gutter={[8, 8]}>
                    <Col>
                        <Typography.Title level={4}>
                            {t('reserve_time')}
                        </Typography.Title>
                    </Col>
                    <Col>
                        <DatePicker.Time
                            value={dayPickerSearch ? dayPickerSearch : null}
                            granularity="day"
                            format={'YYYY-MM-DD'}
                            onValueChange={(value) => {
                                let custom_value = '';
                                custom_value = value?.target ? value?.target.value : value
                                if (value) setDayPickerSearch(new Date(custom_value))
                                else setDayPickerSearch()
                            }}
                            onChange={(value) => {
                                let custom_value = '';
                                custom_value = value?.target ? value?.target.value : value
                                if (value) setDayPickerSearch(new Date(custom_value))
                                else setDayPickerSearch()
                            }}
                        />
                    </Col>
                </Row>]),
                ...tools,
            ])}
            customFormItems={(fieldName, formValues, onValuesChange = () => { }, propsCustomForm) => {
                const staff_id = formValues?.staff_id
                const initialSelectedTimes = formValues?.position_can_reserve_time ?? [];
                const selectableRanges = ["00:00-24:00"]
                const classify_structure_type_id = propsCustomForm.getFieldValue('position_classify_structure_type_data.0.classify_structure_type_id')
                const position_classify_structure_type_data = propsCustomForm.getFieldValue('position_classify_structure_type_data')
                return (<>
                    <Row>
                        <Col span={24}>
                            <Seperator />
                        </Col>
                        <Col span={24}
                            hidden={propsShowKeys?.find((element) => {
                                return element.name === "schedule_id"
                            })?.hidden}>
                            <Typography.Title level={4}>
                                {t('schedule_id')}
                            </Typography.Title>
                        </Col>
                        <Col span={24}
                            hidden={propsShowKeys?.find((element) => {
                                return element.name === "schedule_id"
                            })?.hidden}>
                            <Form.Item
                                name="space_management_position_data.0.space_management_schedule_data.0.schedule_id"
                                label={''}
                            >
                                <Select
                                    options={scheduleController.ResponseData?.map(schedule => (
                                        {
                                            label: schedule?.name_language_data?.find(_ => true)?.language_culture_value ?? schedule?.schedule_id,
                                            value: schedule?.schedule_id
                                        }
                                    ))}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24}
                            hidden={propsShowKeys?.find((element) => {
                                return element.name === "schedule_id"
                            })?.hidden}>
                            <Seperator />
                        </Col>
                        <Col span={24}
                            hidden={propsShowKeys?.find((element) => {
                                return element.name === "position_can_reserve_time"
                            })?.hidden}>
                            <Typography.Title level={4}>
                                {t('seating_and_space_can_reserve_time')}
                            </Typography.Title>
                        </Col>
                        <Col span={24}
                            hidden={propsShowKeys?.find((element) => {
                                return element.name === "position_can_reserve_time"
                            })?.hidden}>
                            <Form.Item
                                name="position_can_reserve_time"
                                label={''}
                            >
                                <TimeSelector
                                    slotInterval={60} // 設定為 60 分鐘時間槽
                                    initialSelectedTimes={initialSelectedTimes}
                                    initialDisabledTimes={[]}
                                    selectableRanges={selectableRanges}  // 可選範圍
                                    maxHours={null} // 最大選擇上限設為 4 小時
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24}
                            hidden={propsShowKeys?.find((element) => {
                                return element.name === "position_can_reserve_time"
                            })?.hidden}>
                            <Seperator />
                        </Col>
                        <Col span={24}
                            hidden={propsShowKeys?.find((element) => {
                                return element.name === "classify_structure_type_id"
                            })?.hidden}>
                            <Typography.Title level={4}>
                                {t('seating_and_space_image')}
                            </Typography.Title>
                        </Col>
                        <Col span={24} key={String(position_classify_structure_type_data)}
                            hidden={propsShowKeys?.find((element) => {
                                return element.name === "classify_structure_type_id"
                            })?.hidden}>
                            <Form.Item
                                labelCol={4}
                                label={t('folder')}
                                name={'position_classify_structure_type_data.0.classify_structure_type_id'}
                            >
                                <MediaContentForm propsDeleteModal={true} />
                            </Form.Item>
                        </Col>
                        {classify_structure_type_id && <Col span={24}>
                            <Form.Item
                                labelCol={4}
                                label={t('photo')}
                                name={'position_classify_structure_type_data.0.classify_structure_type_file'}
                            >
                                <Upload_modal
                                    classify_structure_type_id={classify_structure_type_id}
                                    propsMode='edit'
                                />
                            </Form.Item>
                        </Col>}
                        <Col span={24}
                            hidden={propsShowKeys?.find((element) => {
                                return element.name === "classify_structure_type_id"
                            })?.hidden}>
                            <Seperator />
                        </Col>
                        <Col span={24}
                            hidden={propsShowKeys?.find((element) => {
                                return element.name === "create_user"
                            })?.hidden}>
                            <Typography.Title level={4}>
                                {t('create_user')}
                            </Typography.Title>
                        </Col>
                        <Col span={24}
                            hidden={propsShowKeys?.find((element) => {
                                return element.name === "create_user"
                            })?.hidden}>
                            <StaffSelfForm
                                staff_id={staff_id}
                                propsForm={propsCustomForm}
                            />
                        </Col>
                    </Row >
                </>)
            }}
            customColumns={
                [
                    // {
                    //     title: t('folder'),
                    //     key: "classify_structure_type_id",
                    //     dataIndex: "position_classify_structure_type_data",
                    //     render: (text, record, index) => {
                    //         let position_classify_structure_type_datas = record?.position_classify_structure_type_data || []
                    //         return <>
                    //             {
                    //                 position_classify_structure_type_datas.map((position_classify_structure_type_data) => {
                    //                     return (
                    //                         position_classify_structure_type_data?.classify_structure_type_id && <>
                    //                             <FolderTreeSelect
                    //                                 defaultValue={position_classify_structure_type_data?.classify_structure_type_id || 0}
                    //                                 placeholder=""
                    //                             />
                    //                         </>
                    //                     )
                    //                 })
                    //             }
                    //         </>
                    //     }
                    // },
                    // {
                    //     title: t('file'),
                    //     key: "classify_structure_type_id",
                    //     dataIndex: "position_classify_structure_type_data",
                    //     render: (text, record, index) => {
                    //         let position_classify_structure_type_datas = record?.position_classify_structure_type_data || []
                    //         return <>
                    //             {
                    //                 position_classify_structure_type_datas.map((position_classify_structure_type_data) => {
                    //                     return (
                    //                         <Button onClick={() => {
                    //                             Modal.info({
                    //                                 title: '',
                    //                                 content: <>
                    //                                     <GalleryMain
                    //                                         wrap={true}
                    //                                         propsClassifyStructureTypeId={position_classify_structure_type_data?.classify_structure_type_id}
                    //                                     />
                    //                                 </>
                    //                             })
                    //                         }}>檢視圖片</Button>
                    //                     )
                    //                 })
                    //             }

                    //         </>
                    //     }
                    // },
                    {
                        title: t("seating_and_space_status"),
                        key: "seating_and_space_status",
                        dataIndex: "seating_and_space_status",
                        canFilter: true,
                        filterType: 'search',
                        width: "10rem",
                        render: (text, record) => <>
                            {text === '否' && <>-</>}
                            {text === '是' && <>
                                {record?.rent_task_data?.find(_ => true)?.serial_name + '-' + record?.rent_task_data?.find(_ => true)?.staff_name}
                                <Button onClick={() => {
                                    rentController.patchData([
                                        {
                                            rent_id: record?.rent_task_data?.find(_ => true)?.rent_id,
                                            task_id: record?.rent_task_data?.find(_ => true)?.task_id,
                                            end_time: dayjs().format('YYYY-MM-DD HH:mm:ss')
                                        }
                                    ])
                                }}>{t('return')}</Button>
                            </>}
                        </>
                    },
                    {
                        title: t("can_reserve_time_string"),
                        key: "can_reserve_time_string",
                        dataIndex: "can_reserve_time_string",
                        canFilter: true,
                        filterType: 'search',
                        width: "10rem",
                        render: (text, record) => <>
                            <Row>
                                {record?.position_can_reserve_time?.map(record_time => <>
                                    <Col span={12}>
                                        <Tag color="geekblue">
                                            {record_time}
                                        </Tag>
                                    </Col>
                                </>)}
                            </Row>
                        </>
                    },
                    {
                        title: t("space_management_schedule_data"),
                        key: "space_management_schedule_data",
                        dataIndex: "space_management_schedule_data",
                        canFilter: true,
                        filterType: 'search',
                        width: "10rem",
                        render: (text, record) => {
                            const queryString = jsonToQueryString({
                                schedule_id: record?.space_management_position_data?.find(_ => true)?.space_management_schedule_data?.find(_ => true)?.schedule_id
                            })
                            return <>
                                {record?.space_management_position_data?.find(_ => true)?.space_management_schedule_data?.find(_ => true)?.name_language_data?.find(_ => true)?.language_culture_value}
                                <Button onClick={() => window.open(`./week_management?${queryString}`, '_blank')}>{t("patch_space_management_schedule_data")}</Button>
                            </>
                        }
                    },
                    {
                        title: t("create_user"),
                        key: "staff_name",
                        dataIndex: "staff_name",
                        canFilter: true,
                        filterType: 'search',
                    },
                    {
                        title: t("create_time"),
                        key: "create_time",
                        dataIndex: "create_time",
                        canFilter: true,
                        filterType: 'search',
                        render: (text, record, index) => <>
                            <Row>
                                <Col span={24}>
                                    {record?.create_time}
                                </Col>
                            </Row>
                        </>
                    },
                ]}
            propsShowKeys={propsShowKeys}
            rowSelectionMode={rowSelectionMode}
            propsClassifyStructureTypeId={propsClassifyStructureTypeId}
            propsCardRenderMode={propsCardRenderMode}
            propsCustomRender={(record, { PatchButton, DeleteButton }) => {
                let position_classify_structure_type_datas = record?.position_classify_structure_type_data || []
                return <>
                    <div
                        onClick={() => navigate('./space_management_detail?' + jsonToQueryString({ space_management_id: record?.space_management_position_data?.find(_ => true)?.space_management_id }))}
                    >
                        <Card
                            title={<>
                                {
                                    position_classify_structure_type_datas.map((position_classify_structure_type_data) => {
                                        return <>
                                            <GalleryMain
                                                wrap={true}
                                                propsClassifyStructureTypeId={position_classify_structure_type_data?.classify_structure_type_id}
                                                firstData
                                            />
                                        </>
                                    })
                                }
                            </>}
                        >
                            <Row>
                                <Col span={24}>
                                    {record?.name_language_data?.find(_ => true)?.language_culture_value}
                                </Col>
                                <Col>
                                    <Tag>可容納{record?.max}人</Tag>
                                </Col>
                            </Row>
                        </Card>
                    </div >
                </>
            }}
        />
    </>
}

export default SpaceManagement

const StaffSelfForm = ({
    propsForm,
    staff_id
}) => {
    const [form_] = Form.useForm()
    const form = propsForm ?? form_
    const [staffId, setStaffId] = useState()
    useEffect(() => {
        axios.get('/reservation_registration_and_space_management/staff')
            .then((response) => {
                let data = response.data
                setStaffId(data?.data?.find(_ => true)?.staff_id)
            });
    }, [])
    return <>
        <StaffForm
            mode='information'
            staff_id={staff_id ?? staffId}
        ></StaffForm>
    </>
}

export { StaffSelfForm }
const MediaContentForm = ({
    name = "",
    value,
    onChange = () => { },
    onValueChange = () => { },
    propsDeleteModal = false
}) => {
    return <>
        <MediaContent
            propsRowSelectionMode={'radio'}
            propsClassifyStructureTypeId={0}
            defaultSelectedRowsKeys={value !== "" ? [value] : []}
            defaultSelectedRowsInfo={value !== "" ? [{ classify_structure_type_id: value }] : []}
            propsOnValuesChange={(values) => {
                onChange({
                    name,
                    target: {
                        value: values?.find(_ => true)?.classify_structure_type_id
                    }
                })
                onValueChange({
                    name,
                    target: {
                        value: values?.find(_ => true)?.classify_structure_type_id
                    }
                })
            }}
            propsShowKeys={[
                { key: "font_color", name: "font_color", hidden: true, require: false },
                { key: "background_color", name: "background_color", hidden: true, require: false },
                { key: "hashtag_arr", name: "hashtag_arr", hidden: true, require: false },
                { key: "category_arr", name: "category_arr", hidden: true, require: false },
            ]}
            propsDeleteModal={propsDeleteModal}
        />
    </>
}